import cloneDeep from 'lodash/cloneDeep';

var traverse$2 = {exports: {}};

var traverse = traverse$2.exports = function (obj) {
    return new Traverse(obj);
};

function Traverse (obj) {
    this.value = obj;
}

Traverse.prototype.get = function (ps) {
    var node = this.value;
    for (var i = 0; i < ps.length; i ++) {
        var key = ps[i];
        if (!node || !hasOwnProperty.call(node, key)) {
            node = undefined;
            break;
        }
        node = node[key];
    }
    return node;
};

Traverse.prototype.has = function (ps) {
    var node = this.value;
    for (var i = 0; i < ps.length; i ++) {
        var key = ps[i];
        if (!node || !hasOwnProperty.call(node, key)) {
            return false;
        }
        node = node[key];
    }
    return true;
};

Traverse.prototype.set = function (ps, value) {
    var node = this.value;
    for (var i = 0; i < ps.length - 1; i ++) {
        var key = ps[i];
        if (!hasOwnProperty.call(node, key)) node[key] = {};
        node = node[key];
    }
    node[ps[i]] = value;
    return value;
};

Traverse.prototype.map = function (cb) {
    return walk(this.value, cb, true);
};

Traverse.prototype.forEach = function (cb) {
    this.value = walk(this.value, cb, false);
    return this.value;
};

Traverse.prototype.reduce = function (cb, init) {
    var skip = arguments.length === 1;
    var acc = skip ? this.value : init;
    this.forEach(function (x) {
        if (!this.isRoot || !skip) {
            acc = cb.call(this, acc, x);
        }
    });
    return acc;
};

Traverse.prototype.paths = function () {
    var acc = [];
    this.forEach(function (x) {
        acc.push(this.path); 
    });
    return acc;
};

Traverse.prototype.nodes = function () {
    var acc = [];
    this.forEach(function (x) {
        acc.push(this.node);
    });
    return acc;
};

Traverse.prototype.clone = function () {
    var parents = [], nodes = [];
    
    return (function clone (src) {
        for (var i = 0; i < parents.length; i++) {
            if (parents[i] === src) {
                return nodes[i];
            }
        }
        
        if (typeof src === 'object' && src !== null) {
            var dst = copy(src);
            
            parents.push(src);
            nodes.push(dst);
            
            forEach(objectKeys(src), function (key) {
                dst[key] = clone(src[key]);
            });
            
            parents.pop();
            nodes.pop();
            return dst;
        }
        else {
            return src;
        }
    })(this.value);
};

function walk (root, cb, immutable) {
    var path = [];
    var parents = [];
    var alive = true;
    
    return (function walker (node_) {
        var node = immutable ? copy(node_) : node_;
        var modifiers = {};
        
        var keepGoing = true;
        
        var state = {
            node : node,
            node_ : node_,
            path : [].concat(path),
            parent : parents[parents.length - 1],
            parents : parents,
            key : path.slice(-1)[0],
            isRoot : path.length === 0,
            level : path.length,
            circular : null,
            update : function (x, stopHere) {
                if (!state.isRoot) {
                    state.parent.node[state.key] = x;
                }
                state.node = x;
                if (stopHere) keepGoing = false;
            },
            'delete' : function (stopHere) {
                delete state.parent.node[state.key];
                if (stopHere) keepGoing = false;
            },
            remove : function (stopHere) {
                if (isArray(state.parent.node)) {
                    state.parent.node.splice(state.key, 1);
                }
                else {
                    delete state.parent.node[state.key];
                }
                if (stopHere) keepGoing = false;
            },
            keys : null,
            before : function (f) { modifiers.before = f; },
            after : function (f) { modifiers.after = f; },
            pre : function (f) { modifiers.pre = f; },
            post : function (f) { modifiers.post = f; },
            stop : function () { alive = false; },
            block : function () { keepGoing = false; }
        };
        
        if (!alive) return state;
        
        function updateState() {
            if (typeof state.node === 'object' && state.node !== null) {
                if (!state.keys || state.node_ !== state.node) {
                    state.keys = objectKeys(state.node);
                }
                
                state.isLeaf = state.keys.length == 0;
                
                for (var i = 0; i < parents.length; i++) {
                    if (parents[i].node_ === node_) {
                        state.circular = parents[i];
                        break;
                    }
                }
            }
            else {
                state.isLeaf = true;
                state.keys = null;
            }
            
            state.notLeaf = !state.isLeaf;
            state.notRoot = !state.isRoot;
        }
        
        updateState();
        
        // use return values to update if defined
        var ret = cb.call(state, state.node);
        if (ret !== undefined && state.update) state.update(ret);
        
        if (modifiers.before) modifiers.before.call(state, state.node);
        
        if (!keepGoing) return state;
        
        if (typeof state.node == 'object'
        && state.node !== null && !state.circular) {
            parents.push(state);
            
            updateState();
            
            forEach(state.keys, function (key, i) {
                path.push(key);
                
                if (modifiers.pre) modifiers.pre.call(state, state.node[key], key);
                
                var child = walker(state.node[key]);
                if (immutable && hasOwnProperty.call(state.node, key)) {
                    state.node[key] = child.node;
                }
                
                child.isLast = i == state.keys.length - 1;
                child.isFirst = i == 0;
                
                if (modifiers.post) modifiers.post.call(state, child);
                
                path.pop();
            });
            parents.pop();
        }
        
        if (modifiers.after) modifiers.after.call(state, state.node);
        
        return state;
    })(root).node;
}

function copy (src) {
    if (typeof src === 'object' && src !== null) {
        var dst;
        
        if (isArray(src)) {
            dst = [];
        }
        else if (isDate(src)) {
            dst = new Date(src.getTime ? src.getTime() : src);
        }
        else if (isRegExp(src)) {
            dst = new RegExp(src);
        }
        else if (isError(src)) {
            dst = { message: src.message };
        }
        else if (isBoolean(src)) {
            dst = new Boolean(src);
        }
        else if (isNumber(src)) {
            dst = new Number(src);
        }
        else if (isString(src)) {
            dst = new String(src);
        }
        else if (Object.create && Object.getPrototypeOf) {
            dst = Object.create(Object.getPrototypeOf(src));
        }
        else if (src.constructor === Object) {
            dst = {};
        }
        else {
            var proto =
                (src.constructor && src.constructor.prototype)
                || src.__proto__
                || {}
            ;
            var T = function () {};
            T.prototype = proto;
            dst = new T;
        }
        
        forEach(objectKeys(src), function (key) {
            dst[key] = src[key];
        });
        return dst;
    }
    else return src;
}

var objectKeys = Object.keys || function keys (obj) {
    var res = [];
    for (var key in obj) res.push(key);
    return res;
};

function toS (obj) { return Object.prototype.toString.call(obj) }
function isDate (obj) { return toS(obj) === '[object Date]' }
function isRegExp (obj) { return toS(obj) === '[object RegExp]' }
function isError (obj) { return toS(obj) === '[object Error]' }
function isBoolean (obj) { return toS(obj) === '[object Boolean]' }
function isNumber (obj) { return toS(obj) === '[object Number]' }
function isString (obj) { return toS(obj) === '[object String]' }

var isArray = Array.isArray || function isArray (xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};

var forEach = function (xs, fn) {
    if (xs.forEach) return xs.forEach(fn)
    else for (var i = 0; i < xs.length; i++) {
        fn(xs[i], i, xs);
    }
};

forEach(objectKeys(Traverse.prototype), function (key) {
    traverse[key] = function (obj) {
        var args = [].slice.call(arguments, 1);
        var t = new Traverse(obj);
        return t[key].apply(t, args);
    };
});

var hasOwnProperty = Object.hasOwnProperty || function (obj, key) {
    return key in obj;
};

var traverse$1 = traverse$2.exports;

function round(n) {
  return Math.round((n + Number.EPSILON) * 100000) / 100000;
}

function r90(x, y, yTranslate) {
  return {
    x: y + yTranslate === 0 ? 0 : -round(y + yTranslate),
    y: round(x)
  };
}

function rotate90Paths(paths, yTranslate) {
  return paths.map(path => {
    const {
      x: ax,
      y: ay
    } = r90(path.anchorX, path.anchorY, yTranslate);
    path = { ...path,
      anchorX: ax,
      anchorY: ay
    };
    path.pathPoints = path.pathPoints.map(point => {
      const {
        x: ex,
        y: ey
      } = r90(point.endPointX, point.endPointY, yTranslate);
      point = { ...point,
        endPointX: ex,
        endPointY: ey
      };
      const {
        firstControlPointX,
        firstControlPointY,
        secondControlPointX,
        secondControlPointY
      } = point;

      if (typeof firstControlPointX === "number" && typeof firstControlPointY === "number" && typeof secondControlPointX === "number" && typeof secondControlPointY === "number") {
        const {
          x: cx1,
          y: cy1
        } = r90(firstControlPointX, firstControlPointY, yTranslate);
        const {
          x: cx2,
          y: cy2
        } = r90(secondControlPointX, secondControlPointY, yTranslate);
        point = { ...point,
          firstControlPointX: cx1,
          firstControlPointY: cy1,
          secondControlPointX: cx2,
          secondControlPointY: cy2
        };
      }

      return point;
    });
    return path;
  });
} // Leave bounding position at top left of surface


function rotate90Position(position) {
  return { ...position,
    width: position.height,
    height: position.width
  };
}

function rotate90OrnamentPositions(positions, yTranslate) {
  return positions.map(position => {
    const {
      x: leftCm,
      y: topCm
    } = r90(position.leftCm, position.topCm, yTranslate);
    return { ...position,
      leftCm,
      topCm
    };
  });
}

function rotate90(surface) {
  const rotatedSurface = { ...cloneDeep(surface),
    widthCm: surface.heightCm,
    heightCm: surface.widthCm
  };
  const yTranslate = -surface.heightCm;
  traverse$1(rotatedSurface).forEach(function () {
    if (this.key === "paths") {
      this.update(rotate90Paths(this.node, yTranslate), true);
    } else if (this.key === "position") {
      this.update(rotate90Position(this.node), true);
    } else if (this.key === "positions") {
      this.update(rotate90OrnamentPositions(this.node, yTranslate), true);
    }
  });
  return rotatedSurface;
}

/**
 * Checks the projectionId. It is a static projection if it is not a url or json object.
 */

function isStaticProjection(projectionId) {
  try {
    new URL(projectionId);
    return false;
  } catch (_) {
    try {
      JSON.parse(projectionId);
      return false;
    } catch (_) {
      return true;
    }
  }
}

function getReverseProjection(projectionId) {
  switch (projectionId) {
    case "ROTATE_90":
      return "ROTATE_270";

    case "ROTATE_270":
      return "ROTATE_90";

    case "90_270_EVEN_ODD":
      return "90_270_ODD_EVEN";

    case "90_270_ODD_EVEN":
      return "90_270_EVEN_ODD";

    default:
      return projectionId;
  }
}
/**
 * Rotates all views based on the static projectionId in increments of 90 degrees
 */


function getRotatedDesignViews({
  designViews,
  projectionId
}, unrotate = false) {
  // projectionIds and format can be found on cimpress documentation:
  // https://cimpress-support.atlassian.net/wiki/spaces/CI/pages/298844816/Panel+Projections
  const resolvedProjectionId = unrotate ? getReverseProjection(projectionId) : projectionId;

  if (typeof resolvedProjectionId === "string" && isStaticProjection(resolvedProjectionId)) {
    const projectionDetails = resolvedProjectionId.split("_");
    const singleRotation = projectionDetails.length === 2;

    if (singleRotation) {
      const rotateAngle = parseInt(projectionDetails[1]); // map each view against the rotate angle

      const rotatedDesignViews = designViews.map(designView => {
        let amountToRotate = rotateAngle;
        let rotatedView = cloneDeep(designView);

        while (amountToRotate > 0) {
          rotatedView = rotate90(rotatedView);
          amountToRotate -= 90;
        }

        return rotatedView;
      });
      return {
        designViews: rotatedDesignViews,
        projectionId
      };
    } // multiple rotations


    const angle1Ordinal = projectionDetails[2]; // since we start at index 0, we always want the first angle to be the value of ODD. See designer code note:
    // https://gitlab.com/Cimpress-Technology/DocDesign/designexperience/cimpress-designer/-/blob/master/app/core/util/alternativeOrientationUtil.js#L10

    const oddPageRotationAngle = angle1Ordinal === "ODD" ? parseInt(projectionDetails[0], 10) : parseInt(projectionDetails[1], 10);
    const evenPageRotationAngle = angle1Ordinal === "ODD" ? parseInt(projectionDetails[1], 10) : parseInt(projectionDetails[0], 10); // for each view, map against the rotate angle depending on page number

    const rotatedDesignViews = designViews.map((view, index) => {
      let rotatedView = cloneDeep(view);
      const rotateAngle = index % 2 == 0 ? oddPageRotationAngle : evenPageRotationAngle;
      let amountToRotate = rotateAngle;

      while (amountToRotate > 0) {
        rotatedView = rotate90(rotatedView);
        amountToRotate -= 90;
      }

      return rotatedView;
    });
    return {
      designViews: rotatedDesignViews,
      projectionId
    };
  }

  return {
    designViews,
    projectionId
  };
}
function castToV2DesignViewSpecification({
  views,
  projectionId
}) {
  return {
    designViews: views,
    projectionId
  };
}

export { castToV2DesignViewSpecification, getRotatedDesignViews, isStaticProjection };
//# sourceMappingURL=index.js.map
